module.exports = __webpack_public_path__ + "static/media/app-store-icon-edited-2-reduced.1c79a09d.jp2";